export default "/backend/static/media/noData.e45691e3.png";